import { createContext, useContext, useState } from "react";
import { ValidationDocumentQueue } from "./ValidationDocumentQueue";
import { toast } from "react-toastify";

interface QueueContextType {
  addProcess: (id: number) => void;
}

const QueueContext = createContext<QueueContextType | null>(null);

export const useQueueProvider = () => {
  const context = useContext(QueueContext);
  if (!context) throw new Error("useQueue debe usarse dentro de QueueProvider");
  return context;
};

export const QueueProvider = ({ children }: any) => {

  const [processId, setProcessId] = useState<number | null>(null);

  const addProcess = (id: number) => {
    setProcessId((prev) => {

      if (prev !== null) {
        toast.warning("⚠️ Ya hay un documento en proceso, espera a que termine");
        return prev;
      }

      return id;
    });
  };

  const removeProcess = () => {
    setProcessId(null);
  };

  return (
    <QueueContext.Provider value={{ addProcess }}>
      {children}

      {processId && (
        <ValidationDocumentQueue
          idprocessqueue={processId}
          onFinish={removeProcess}
        />
      )}
    </QueueContext.Provider>
  );
};